import React from 'react';
import {observer} from 'mobx-react';

declare var __normal_ship_text: string;
declare var __fast_ship_text: string;
declare var __fast_ship_text_mobile: string;

const ProductShipping: React.FC = observer(() => {
    return (
        <div>
            <div
                className="prod-sub-header toggle-bs"
                role="button"
                tabIndex={0}
                data-bs-toggle="collapse"
                data-bs-target="#shipping"
                aria-expanded={false}
                aria-controls="shipping"
                onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        // @ts-ignore
                        document.getElementById('shipping').click();
                    }
                }}
            >
                Shipping
            </div>
            <div
                id="shipping"
                className="collapse plh"
            >
                <div>Every frame is handcrafted and ships in 5-7 business days. Need it faster? Look for the Fast-Ship icon; those select styles ship in 1-2 days. Delivery time varies by destination and the shipping speed you select.</div>
                <div style={{paddingTop: 12}}>We ship to APO/FPO and internationally. For overseas orders, we use museum-quality acrylic for safe delivery. It is clear, lightweight, shatter-resistant, and blocks up to 45% UV.</div>
                {/* {__fast_ship_text && <div style={{paddingTop:12}}>This item ships within 1-2 business days - anywhere in the US. We can also ship APO, FPO, and internationally.</div>}
                {!__fast_ship_text && <div style={{paddingTop:12}}>This item ships within 5-7 business days - anywhere in the US. We can also ship APO, FPO, and internationally.</div>} */}
            </div>
        </div>
    );
});

export default ProductShipping;
